import React, { useContext } from "react";
import { Button, Tooltip } from "@mui/material";

import FavouriteContext from "../../contexts/LocalStorageContext";
import DisableHotkeyContext from "../../contexts/DisableHotkeyContext";
import { useShortcut } from "../../hooks/useShortcut";

interface FavouriteControlsProps {
  id: string;
}

const FavouriteControls: React.FC<FavouriteControlsProps> = ({ id }: FavouriteControlsProps) => {
  const { favouriteIdArray, setFavouriteIdArray } = useContext(FavouriteContext);
  const { disableHotkey } = useContext(DisableHotkeyContext);

  const handleFavourites = () => {
    let favourites = favouriteIdArray ? [...favouriteIdArray] : [];
    if (favourites.includes(id)) {
      favourites = favourites.filter((x) => x !== id);
    } else {
      favourites.push(id);
    }
    setFavouriteIdArray(favourites);
  };

  useShortcut(handleFavourites, ["r"], disableHotkey);

  return (
    <div>
      <Tooltip title="use (r/R) to favourite/remove item">
        <Button variant="outlined" onClick={handleFavourites}>
          {favouriteIdArray && favouriteIdArray.includes(id) ? "Unfavourite" : "Favourite"}
        </Button>
      </Tooltip>
    </div>
  );
};

export default FavouriteControls;
